import React, { memo, useState, } from "react";

// Style
import "./Tabs.scss";

// ClassNames
import clsx from "clsx";

// Navigation
import { useNavigate } from "react-router-dom";

// Lib
import { addQueryParamsToUrl, urlParams } from "lib/search";

export const Tabs: React.FC<any> = (props) => {
  const {
    tabs = [],
    type = "",
    callback = () => {
    },
    className = "",
    nameKeyTab = "tab",
    defaultScreen = "",
    withUrlParam = true,
    classNameContent = "",
  } = props;
  let result = "";
  const navigate = useNavigate();

  const [screen, setScreen] = useState(nameKeyTab);

  const tab: string = urlParams(null).get(nameKeyTab) || defaultScreen as string;

  const handleTabClick = (value: string) => () => {
    if(withUrlParam) {
      addQueryParamsToUrl({ [nameKeyTab]: value }, navigate);
    }

    if(!withUrlParam) {
      setScreen(value);
    }

    callback && callback(value);
  };

  if(!withUrlParam) {
    result = tabs.find((x: any) => x.url === screen)?.content;
  }

  if(withUrlParam) {
    result = tabs.find((x: any) => x.url === tab)?.content;
  }

  const cnWrapper = clsx(
    "tabs-ui",
    className ? className : "",
    type === "primary" ? "tabs-ui__primary" : "",
    type === "secondary" ? "tabs-ui__secondary" : ""
  );

  const cnWrapperContent = clsx(
    "tabs-ui__tab-content",
    classNameContent ? classNameContent : "",
  );

  return (
    <div className={cnWrapper}>
      <div className="flex tabs-ui__tab-list">
        {tabs.map((item: any, index: number) => (
          <div
            key={index}
            style={item.url === tab ? { zIndex: 2 } : {}}
            onClick={handleTabClick(item?.url || "")}
            className={`tabs-ui__tab ${
              item.url === tab ? "tabs-ui__tab--active" : ""
            }`}
          >
            <span className="relative">{item.label}</span>
          </div>
        ))}
      </div>
      <div className={cnWrapperContent}>{(!!result && result) || null}</div>
    </div>
  );
};

export default memo(Tabs);
